import React, { ReactNode, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import SecondaryButton from "../buttons/SecondaryButton";
import Button from "../buttons/Button";
import TextArea from "../inputfields/TextArea";
import PercentageInput from "../inputfields/PercentageInput";
import useTranslation from "../CustomHooks/useTranslation";
import { inputFieldContent } from "../inputfields/InputFieldContent";

interface CustomModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  subText?: string;
  children?: ReactNode;
  primaryButtonText:string;
  secondaryButtonText:string;
  handelSubmit: (text? : string) =>  void;
  textArea?: boolean;
  buttonColor? : string;
  buttonLoading?: boolean;
  buttonWidth?: string;
  primaryButtonClassName?: string;
  input?: {
    labelName: string;
    id: string;
  };
  onHandleClose?: () => void;
}

const CustomModal: React.FC<CustomModalProps> = ({buttonLoading, buttonWidth, textArea,onHandleClose, isOpen, onClose, buttonColor, title, subText, children, primaryButtonText, secondaryButtonText, handelSubmit, primaryButtonClassName, input }) => {
  const [text, setText] = useState<string>("");
  const [textError, setTextError] = useState<string>('');
  const { translate, notEnglish } = useTranslation(inputFieldContent)
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (e.target === e.currentTarget) {
      onClose(); // Close the modal when clicking the overlay
    }
  };
  const handleSubmitButtonClick = () => {
      if (textArea && text === "") {
        setTextError("This field is required");
      } else if (input && text === "") {
        setTextError("This field is required");
      } else {
        handelSubmit(text);
      }
  }
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={handleOverlayClick} // Listen for clicks on the overlay
          dir={notEnglish ? "rtl" : "ltr"}
        >
          <motion.div
            className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full relative"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.8 }}
          >
            {title && <h2 className="text-heading5 font-medium pb-2 mb-2 text-primary_text border-b border-b-outline">{title}</h2>}
            {subText && <h2 className="subTitle text-secondary_text">{subText}</h2>}
            {input && <PercentageInput label={input.labelName} initialValue={text} setText={setText} setTextError={setTextError} errorMessage={textError} onChange={() => {
              handleSubmitButtonClick
            }} required={true} />}
            {textArea && <TextArea text={text} setText={setText} textError={textError} setTextError={setTextError}/>}

            <div>{children}</div>
            <div className={`flex ${textArea ? 'mt-1' : 'mt-6'} gap-6`}>
              <SecondaryButton
                buttonName={secondaryButtonText}
                className="px-4 py-2 h-fit"
                handleClick={onHandleClose ? onHandleClose : onClose}
                testId="cancel-btn"
                buttonDisabled={buttonLoading}
              />
              <Button 
                buttonName={primaryButtonText}
                className={`py-2.5 ${primaryButtonClassName} px-4 rounded-[6px] `}
                textSize={'text-large'}
                buttonOnclick={handleSubmitButtonClick}
                testId={`${primaryButtonText.toLowerCase()}-btn`}
                loading={buttonLoading}
                bgColor={buttonColor}
                buttonWidth={buttonWidth}
                buttonHight="h-[42px]"
              />
            </div>

          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CustomModal;
